export declare namespace GroupedTableTokenSections {
	interface ExpandCell {
		width: string;
	}

	interface GroupRow {
		background: string;
		expandOrCollapseControl: {
			color: string;
			size: string;
		};
		name: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
		subtitle: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
		itemCount: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
	}

	interface DetailRow {
		primaryDataItem: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
		secondaryDataItem: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
	}
}

export type GroupedTableTokens = {
	expandCell: GroupedTableTokenSections.ExpandCell;
	groupRow: GroupedTableTokenSections.GroupRow;
	detailRow: GroupedTableTokenSections.DetailRow;
};

export const expandCell: GroupedTableTokenSections.ExpandCell = {
	width: '2.25rem',
};

export const groupRow: GroupedTableTokenSections.GroupRow = {
	background: '{content.subtle.background}',
	expandOrCollapseControl: {
		color: '{primary.400}',
		size: '0.75rem',
	},
	name: {
		color: '{surface.800}',
		fontWeight: '600',
		fontSize: '0.75rem',
		lineHeight: '1.5rem',
	},
	subtitle: {
		color: '{surface.400}',
		fontWeight: '400',
		fontSize: '0.75rem',
		lineHeight: '1.125rem',
	},
	itemCount: {
		color: '{primary.400}',
		fontWeight: '600',
		fontSize: '0.75rem',
		lineHeight: '1.5rem',
	},
};

export const detailRow: GroupedTableTokenSections.DetailRow = {
	primaryDataItem: {
		color: '{surface.800}',
		fontWeight: '400',
		fontSize: '0.875rem',
		lineHeight: '1.5rem',
	},
	secondaryDataItem: {
		color: '{surface.950}',
		fontWeight: '400',
		fontSize: '0.75rem',
		lineHeight: '1.125rem',
	},
};

export default {
	expandCell,
	groupRow,
	detailRow,
} satisfies GroupedTableTokens;
